export interface FilterOptions {
    filter_by?: any;
    sort_by?: any;
  }
  
  export enum SortingOptions {
    ASC,
    DESC,
  }
  
  export interface ListSortBy {
    sort_type?: SortingOptions;
    sort_by?: string;
  }
  